<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="500"
    :loading="loading"
    @close="onClose"
    @ok="onSubmit((e) => onSubmitFun(e))"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <e-input
          title="标题"
          :validate="validateInfos.title"
          v-model:value="modelRef.title"
        />

        <e-input
          title="标识"
          :validate="validateInfos.name"
          v-model:value="modelRef.name"
        />

        <e-select
          title="类型"
          v-model:value="modelRef.type"
          :options="$store.state.app.types"
        />

        <e-input-number
          title="顺序"
          :labelCol="4"
          :valueCol="18"
          :validate="validateInfos.sort"
          v-model:value="modelRef.sort"
        />

        <e-textarea
          title="备注"
          :validate="validateInfos.remark"
          v-model:value="modelRef.remark"
        />

      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { ConfigClass } from '@/apis/config'

const useForm = Form.useForm
const api = new ConfigClass()
export default defineComponent({
  components: {},
  mixins: [form],
  emits: ['ok'],
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const isEdit = ref(false)
    const title = ref('')

    const modelRef = reactive(api.modelRef)
    const rulesRef = reactive(api.rulesRef)

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    const onClose = () => {
      resetFields()
      loading.value = false
      visible.value = false
    }

    const roles = ref([])

    return {
      title,
      visible,
      loading,
      isEdit,
      modelRef,
      validateInfos,
      roles,
      resetFields,
      validate,
      onClose
    }
  },

  methods: {
    open () {
      this.title = '添加配置'
      this.visible = true
    },

    onSubmitFun (e) {
      const data = toRaw(e)

      api.create(data).then(() => {
        this.loading = false
        this.$message.success('添加成功')
        this.$emit('ok')
        this.onClose()
      })
    }
  }
})
</script>
